var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_setup.hasHelp)?_c('b-popover',{attrs:{"target":() => {
                return _vm.$refs.helpTarget;
            },"triggers":"hover","placement":"bottom"}},[_c(_setup.ConfigurationMarkdown,{attrs:{"markdown":_setup.help,"admin":true}})],1):_vm._e(),_vm._v(" "),(_setup.hasHelp)?_c('span',{ref:"helpTarget",staticClass:"help-text"},[_vm._v(_vm._s(_vm.text))]):_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }